import $mitt from 'mitt';
import { defaultImport } from 'default-import';
import { useSyncExternalStore } from 'use-sync-external-store/shim/index.js';
const mitt = defaultImport($mitt);
export function createSignal(initial, equals = (c, t) => c == t) {
    const valueRef = { current: initial };
    let historySet = new Set([initial]);
    const emitter = mitt();
    function update(input) {
        const previousValue = valueRef.current;
        valueRef.current = input;
        if (!equals(valueRef.current, previousValue)) {
            historySet.add(valueRef.current);
            emitter.emit('change', { value: valueRef.current, previousValue });
        }
    }
    function useSignal() {
        const stateValue = useSyncExternalStore((callback) => {
            emitter.on('change', callback);
            return () => emitter.off('change', callback);
        }, () => valueRef.current, () => valueRef.current);
        return [stateValue, update];
    }
    return {
        update,
        ref: valueRef,
        emitter,
        history: historySet,
        use: useSignal,
    };
}
